var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-section',{attrs:{"id":"all-blogs"}},[_c('base-section-heading',{attrs:{"color":"grey lighten-2","title":"Blogs"}}),_c('v-container',[_c('v-row',_vm._l((_vm.cards),function(card){return _c('v-col',{key:card._id,attrs:{"cols":"12","md":"4"}},[_c('single-content',{attrs:{"content":card}})],1)}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }